import { jsx as n, jsxs as o } from "react/jsx-runtime";
import { Icon as c } from "../Icon/Icon.js";
const l = "DescriptionTextColumn-module_title__zJDSE",
  s = "DescriptionTextColumn-module_leadIn__0DXq3",
  r = "DescriptionTextColumn-module_content-container__BMDPa",
  m = "DescriptionTextColumn-module_content-left__v-VHt",
  d = "DescriptionTextColumn-module_content-right__M2QbT",
  h = "DescriptionTextColumn-module_highlights__sOp1v",
  a = "DescriptionTextColumn-module_item__H1Uns",
  e = {
    title: l,
    leadIn: s,
    contentContainer: r,
    contentLeft: m,
    contentRight: d,
    highlights: h,
    item: a
  },
  _ = t => /* @__PURE__ */n("div", {
    className: e.title,
    children: t.children
  }),
  C = t => /* @__PURE__ */n("div", {
    className: e.leadIn,
    children: t.children
  }),
  x = t => /* @__PURE__ */n("div", {
    className: e.contentLeft,
    children: t.children
  }),
  D = t => /* @__PURE__ */n("div", {
    className: e.contentRight,
    children: t.children
  }),
  T = t => /* @__PURE__ */n("div", {
    className: e.contentContainer,
    children: t.children
  }),
  g = t => /* @__PURE__ */n("div", {
    className: e.descriptionText,
    children: t.children
  }),
  v = _ref => {
    let {
      items: t
    } = _ref;
    return /* @__PURE__ */n("ul", {
      className: e.highlights,
      children: t.map(i => /* @__PURE__ */o("li", {
        className: e.item,
        children: [/* @__PURE__ */n(c, {
          name: i.icon,
          padding: "inline",
          size: "1.5x"
        }), " ", i.label]
      }, i.key))
    });
  };
export { g as DescriptionTextColumn, T as DescriptionTextColumnContent, x as DescriptionTextColumnContentLeft, D as DescriptionTextColumnContentRight, v as DescriptionTextColumnIconHighlights, C as DescriptionTextColumnLeadIn, _ as DescriptionTextColumnTitle };